export const splitTreatmentIndex = [
  'av_form',
  'nicotine-strength-text',
  'av-pending-review-page',
  'convert-order-to-subscription',
  'default-to-autoship',
  'pods_progress_bar',
];
